import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-channel.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-channel.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class ServiceChannelEffects {



  createServiceChannel$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceChannel),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_DELIVERY_CHANNEL,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceChannels({ serviceChannels: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServiceDeliveryChannel$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceChannel),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_SERVICE_DELIVERY_CHANNELS,
        variables: {
          channelUniqueId: action?.channelUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceChannel({ id: action.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllServiceDeliveryChannels$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceChannel),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICE_DELIVERY_CHANNELS,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: action.serviceUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service delivery channels'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceChannels({ serviceChannels: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
